<!-- VERTICAL LAYOUT 1 -->
<ng-container>
    <vertical-layout-1></vertical-layout-1>
</ng-container>
